var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"xtable"},[(this.hide)?_c('EasyTable',{ref:"easyTable",attrs:{"data":_vm.entityJson,"hide":_vm.hide}}):_c('EasyTable2',{ref:"easyTable",attrs:{"data":_vm.entityJson,"hide":_vm.hide}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }